mutation DepartmentGroupDelete($input: DepartmentGroupDeleteInput!) {
  departmentGroupDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
